document.addEventListener('DOMContentLoaded', function () {
  initMobileDrawer();
  initCountdowns();
  initProductForms();
  initCartToast();
});

/* ---------------- Mobile drawer ---------------- */
function initMobileDrawer() {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var openers = document.querySelectorAll('[data-drawer-open]');
  var closers = drawer.querySelectorAll('[data-drawer-close]');

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  closers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });
}

/* ---------------- Countdown timers ---------------- */
function initCountdowns() {
  var blocks = document.querySelectorAll('[data-countdown]');
  blocks.forEach(function (block) {
    var target = parseInt(block.getAttribute('data-target'), 10) * 1000;
    if (!target) return;
    var days = block.querySelector('[data-countdown-days]');
    var hours = block.querySelector('[data-countdown-hours]');
    var minutes = block.querySelector('[data-countdown-minutes]');
    var seconds = block.querySelector('[data-countdown-seconds]');

    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff / 3600000) % 24);
      var m = Math.floor((diff / 60000) % 60);
      var s = Math.floor((diff / 1000) % 60);
      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
}

/* ---------------- Product page: gallery + variant picker + add to cart ---------------- */
function initProductForms() {
  var roots = document.querySelectorAll('[data-product-root]');
  roots.forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Dastoor theme: could not parse product JSON', e);
      return;
    }

    initGallery(root, product);
    initOptionPicker(root, product);
    initQuantity(root);
    initAddToCart(root, product);
  });
}

function initGallery(root, product) {
  var thumbs = root.querySelectorAll('[data-gallery-thumb]');
  var images = root.querySelectorAll('[data-gallery-image]');
  if (!thumbs.length || !images.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.getAttribute('data-index');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      images.forEach(function (img) { img.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var match = root.querySelector('[data-gallery-image][data-index="' + index + '"]');
      if (match) match.classList.add('is-active');
    });
  });
}

function showGalleryImage(root, imageId) {
  if (!imageId) return;
  var images = root.querySelectorAll('[data-gallery-image]');
  var thumbs = root.querySelectorAll('[data-gallery-thumb]');
  var target = root.querySelector('[data-gallery-image][data-image-id="' + imageId + '"]');
  if (!target) return;
  images.forEach(function (img) { img.classList.remove('is-active'); });
  thumbs.forEach(function (t) { t.classList.remove('is-active'); });
  target.classList.add('is-active');
  var idx = target.getAttribute('data-index');
  var thumb = root.querySelector('[data-gallery-thumb][data-index="' + idx + '"]');
  if (thumb) thumb.classList.add('is-active');
}

/* Builds the option picker UI. Replicates the Unstitched / Stitched preference
   toggle when a single "Size"-style option contains an unstitched value;
   otherwise falls back to a generic button group per option. */
function initOptionPicker(root, product) {
  var container = root.querySelector('[data-option-groups]');
  if (!container || !product.options_with_values) return;

  var options = product.options_with_values;
  var selected = {};
  options.forEach(function (opt) { selected[opt.position] = opt.values[0]; });

  var singleSizeOption = options.length === 1 ? options[0] : null;
  var unstitchedValue = null;
  if (singleSizeOption) {
    unstitchedValue = singleSizeOption.values.find(function (v) {
      return /un.?sti.?ch/i.test(v);
    });
  }

  function findVariant() {
    return product.variants.find(function (v) {
      return options.every(function (opt, i) {
        var key = 'option' + (i + 1);
        return v[key] === selected[opt.position];
      });
    });
  }

  function render() {
    container.innerHTML = '';

    if (singleSizeOption && unstitchedValue) {
      var stitchedValues = singleSizeOption.values.filter(function (v) { return v !== unstitchedValue; });
      var mode = selected[singleSizeOption.position] === unstitchedValue ? 'unstitched' : 'stitched';

      if (stitchedValues.length) {
        var modeWrap = document.createElement('div');
        modeWrap.className = 'product-option';
        modeWrap.innerHTML = '<div class="label-row"><span class="label">Preference</span></div>';
        var modeToggle = document.createElement('div');
        modeToggle.className = 'mode-toggle';

        ['unstitched', 'stitched'].forEach(function (m) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'is-' + m + (mode === m ? ' is-active' : '');
          if (mode === m) btn.classList.add('is-active');
          btn.innerHTML = (m.charAt(0).toUpperCase() + m.slice(1)) +
            '<span class="sub">' + (m === 'unstitched' ? 'Fabric only' : 'Made to measure') + '</span>';
          btn.addEventListener('click', function () {
            selected[singleSizeOption.position] = m === 'unstitched' ? unstitchedValue : stitchedValues[0];
            render();
          });
          modeToggle.appendChild(btn);
        });
        modeWrap.appendChild(modeToggle);
        container.appendChild(modeWrap);
      }

      if (mode === 'stitched' && stitchedValues.length) {
        var sizeWrap = document.createElement('div');
        sizeWrap.className = 'product-option';
        sizeWrap.innerHTML = '<div class="label-row"><span class="label">Size</span></div>';
        var sizeOptions = document.createElement('div');
        sizeOptions.className = 'size-options';
        stitchedValues.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = val;
          if (selected[singleSizeOption.position] === val) btn.classList.add('is-active');
          btn.addEventListener('click', function () {
            selected[singleSizeOption.position] = val;
            render();
          });
          sizeOptions.appendChild(btn);
        });
        sizeWrap.appendChild(sizeOptions);
        container.appendChild(sizeWrap);
      }
    } else {
      options.forEach(function (opt) {
        var wrap = document.createElement('div');
        wrap.className = 'product-option';
        wrap.innerHTML = '<div class="label-row"><span class="label">' + opt.name + '</span></div>';
        var group = document.createElement('div');
        group.className = 'size-options';
        opt.values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = val;
          if (selected[opt.position] === val) btn.classList.add('is-active');
          btn.addEventListener('click', function () {
            selected[opt.position] = val;
            render();
          });
          group.appendChild(btn);
        });
        wrap.appendChild(group);
        container.appendChild(wrap);
      });
    }

    updateForVariant(findVariant());
  }

  function updateForVariant(variant) {
    var variantInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var discountEl = root.querySelector('[data-discount-badge]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var saleBadge = root.querySelector('[data-sale-badge]');

    if (!variant) {
      if (addBtn) addBtn.setAttribute('disabled', 'disabled');
      if (addText) addText.textContent = 'Unavailable';
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (comparePriceEl) {
      if (onSale) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.removeAttribute('hidden');
      } else {
        comparePriceEl.setAttribute('hidden', 'hidden');
      }
    }
    if (discountEl) {
      if (onSale) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discountEl.textContent = '\u2212' + pct + '%';
        discountEl.removeAttribute('hidden');
      } else {
        discountEl.setAttribute('hidden', 'hidden');
      }
    }
    if (saleBadge) {
      if (onSale) {
        saleBadge.textContent = 'Sale \u00b7 Save ' + formatMoney(variant.compare_at_price - variant.price);
        saleBadge.style.display = '';
      } else {
        saleBadge.style.display = 'none';
      }
    }

    var qty = root.querySelector('[data-qty-input]');
    var qtyVal = qty ? parseInt(qty.value, 10) || 1 : 1;
    var addLabel = (addBtn && addBtn.getAttribute('data-label')) || 'Add to Bag';
    if (addBtn) {
      if (variant.available) {
        addBtn.removeAttribute('disabled');
        if (addText) addText.textContent = addLabel + ' \u00b7 ' + formatMoney(variant.price * qtyVal);
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        if (addText) addText.textContent = 'Sold Out';
      }
    }

    var buyBtn = root.querySelector('[data-buy-now]');
    if (buyBtn) {
      if (variant.available) {
        buyBtn.removeAttribute('disabled');
      } else {
        buyBtn.setAttribute('disabled', 'disabled');
      }
    }

    if (variant.featured_image && variant.featured_image.id) {
      showGalleryImage(root, variant.featured_image.id);
    }

    root.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: variant } }));
  }

  render();
}

function initQuantity(root) {
  var input = root.querySelector('[data-qty-input]');
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  var addText = root.querySelector('[data-add-to-cart-text]');
  if (!input) return;

  function refreshLabel() {
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    if (!priceEl || !addText) return;
    var unit = parseMoney(priceEl.textContent);
    var qty = parseInt(input.value, 10) || 1;
    var label = (addBtn && addBtn.getAttribute('data-label')) || 'Add to Bag';
    if (addText.textContent.indexOf('Sold Out') === -1 && addText.textContent.indexOf('Unavailable') === -1) {
      addText.textContent = label + ' \u00b7 ' + formatMoney(unit * qty);
    }
  }

  if (minus) minus.addEventListener('click', function () {
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    refreshLabel();
  });
  if (plus) plus.addEventListener('click', function () {
    input.value = (parseInt(input.value, 10) || 1) + 1;
    refreshLabel();
  });
  input.addEventListener('change', function () {
    input.value = Math.max(1, parseInt(input.value, 10) || 1);
    refreshLabel();
  });
}

function initAddToCart(root, product) {
  var form = root.querySelector('[data-product-form] form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    var submitter = e.submitter || document.activeElement;
    var isCheckout = submitter && (submitter.getAttribute('name') === 'checkout' || submitter.hasAttribute('data-buy-now'));

    if (isCheckout) {
      // Let the browser submit the form natively — Shopify adds the item
      // to the cart and redirects straight to checkout. No AJAX needed.
      if (submitter.hasAttribute('disabled')) e.preventDefault();
      return;
    }

    e.preventDefault();
    var addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn && addBtn.hasAttribute('disabled')) return;
    if (addBtn) addBtn.setAttribute('disabled', 'disabled');

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showCartToast(product.title + ' added to your bag');
      })
      .catch(function () {
        showCartToast('Something went wrong. Please try again.');
      })
      .finally(function () {
        if (addBtn) addBtn.removeAttribute('disabled');
      });
  });
}

function updateCartCount(count) {
  document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

/* ---------------- Cart toast ---------------- */
function initCartToast() {
  if (document.getElementById('CartToast')) return;
  var toast = document.createElement('div');
  toast.id = 'CartToast';
  toast.className = 'cart-toast';
  document.body.appendChild(toast);
}

function showCartToast(message) {
  var toast = document.getElementById('CartToast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(function () {
    toast.classList.remove('is-visible');
  }, 2800);
}

/* ---------------- Money helpers (fallback formatting) ---------------- */
function formatMoney(cents) {
  if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
    return Shopify.formatMoney(cents, window.themeMoneyFormat);
  }
  return 'PKR ' + Math.round(cents / 100).toLocaleString('en-PK');
}

function parseMoney(str) {
  var digits = (str || '').replace(/[^0-9]/g, '');
  return (parseInt(digits, 10) || 0) * 100;
}
